<script>
import Layout from '@layouts/main.vue'
import Footer from '@components/footer.vue'
export default {
  metaInfo: {
    title: '都道府県選択 | JAFナビ',
    meta: [{ name: 'description', content: '都道府県選択' }],
  },
  components: { Layout, Footer },
  data() {
    return {
      list: [],
      SHOP_PREFECTURE: '',
    }
  },
  computed: {
    isLinksMode() {
      if (
        this.$store.state.auth.userType == '80' &&
        this.$store.state.auth.loggedIn
      ) {
        return true
      }

      return false;
    },
    selectionheadCSS() {
      if (!this.isLinksMode) {
        return [this.$style.selectionhead];
      } else {
        return [this.$style.selectionhead,this.$style.selectionhead_none_header];
      }
    },
  },
  mounted() {
    // TODO: customer_id : localStorage.getItem('customerID')
    window.dataLayer.push({
      event: 'Webview',
      ap_screen_name: 'JAFナビ_条件を指定して検索_都道府県選択',
    })
    this.list = this.$store.state.area.prefectureList.filter((item) => {
      return item.area === this.$route.query.SHOP_AREA
    })
      sessionStorage.setItem('KEEP_CLOSE', '1')
  },
  methods: {
    setShopArea(val) {
      // sessionStorage.setItem('PRE_SCREEN_ID', 'SU-02-02')
			this.$router.push({
        path: '/facility-municipality',
        query: {
          SHOP_PREFECTURE: val.option_list,
          SHOP_AREA: this.$route.query.SHOP_AREA,
        },
      })
    },
    setArea() {
      // sessionStorage.setItem('PRE_SCREEN_ID', 'SU-02-02')

      this.$router.push({
        name: 'facility-search',
        params: { area: this.$route.query.SHOP_AREA ,
									municipality: '' },
      })
    },
    returnToFacilityArea() {
			const preScreen = sessionStorage.getItem("PRE_SCREEN_ID")

      if(preScreen && preScreen === 'SU-01'){
				// 選択リストから遷移
        sessionStorage.removeItem('PRE_SCREEN_ID')
        this.$router.push({ path: '/' })
      }else{
				this.$router.push({ path: '/facility-area' })
      }
    },
  },
}
</script>
<template>
  <Layout>
    <div :class="$style.prefectureArea">
      <a :class="selectionheadCSS">
        <p :class="$style.head_banner"></p>
        <div>
          <div @click="returnToFacilityArea">
            <span :class="$style.backImg"></span>
            <span :class="$style.backPage">戻る</span></div
          >都道府県から探す
        </div>
        <p :class="$style.head_banner"></p>
      </a>
      <a :class="$style.selectionLinks" @click="setArea">
        <div>
          <span>すべて</span>
          <span :class="$style.nextPage"></span>
        </div>
      </a>
      <a
        v-for="(item, k) in list"
        :key="k"
        :class="$style.selectionLinks"
        @click="setShopArea(item)"
      >
        <div>
          <span>{{ item.option_list }}</span>
          <span :class="$style.nextPage"></span>
        </div>
      </a>
    </div>
    <Footer />
  </Layout>
</template>
<style lang="scss" module>
@import '@design';
@import '../../design/_selection.scss';

.prefectureArea {
  width: 100%;
  min-height: calc(100% - 99px);
  // padding-bottom: 64px;
  margin-top: 1.927vw;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  #jaf_container{
    // height: 90%;
    height: calc(100% - 15vw);
  }
}
</style>
